import React, { useEffect, useState } from "react";
import { addItem, updateItem, deleteItem, getItem } from '../core/database/firebaseFunctions';
import CustomTable from '../components/CustomTable/CustomTable';
import Alert from "../components/Alert/Alert";
import sort from 'fast-sort'

const defaultColumns = [
	{
		title: 'Nome',
		field: 'name',
		required: true,
		editable: true
	}
]

const loadFunction = (setIsLoading, dataLoading) => {
	return async data => {
		setIsLoading(true);
		try {
			await dataLoading(data);
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	}
}

export const EntityListContainer = ({ reload = undefined, hideEdit, hasPower, title, treeList = false, detailsList = false, onAddChildren = () => { }, openDetails = () => { }, onAddClick, onDeleteClick, options = {}, hideDelete = false, active = true, onRowAddContent = undefined, canSelect = false, onEditClick = undefined, parentChildData = undefined, addClauseInItem = false, columns = defaultColumns, tableName, clause, toolbarAppend = undefined }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState([]);

	const verifyError = (dataItem) => {
		let hasError = false;
		const requiredColumns = columns.filter(item => item.required);

		requiredColumns.map(column => {
			if (!dataItem[column.field]) {
				hasError = true;
				Alert.error(`Coluna ${column.name} é obrigatória`)
			}
		})

		return hasError;
	}

	const fetchData = async () => {
		const items = await getItem(tableName, clause, active);
		sort(items).asc(u => u.name)
		setData(items)
	}

	const onRowUpdate = async (dataItem) => {
		let hasError = verifyError(dataItem);

		if (!hasError) {
			const item = await updateItem(tableName, dataItem);
			const index = data.findIndex(item => item.id === dataItem.id);
			data[index] = item;
			setData(data);
			return item;
		}
	}

	const onRowAdd = async (dataItem) => {
		let hasError = verifyError(dataItem);

		if (!hasError) {
			if (!onRowAddContent) {
				const item = await addItem(tableName, addClauseInItem ? { ...dataItem, ...clause } : dataItem);
				setData(data.concat([item]))
				return item;
			} else {
				const item = await onRowAddContent(addClauseInItem ? { ...dataItem, ...clause } : dataItem);
				setData(data.concat([item]))
				return item;
			}
		}
	}

	const onRowDelete = async (dataItem) => {
		const item = await deleteItem(tableName, dataItem.id);
		setData(data.filter(item => item.id !== dataItem.id));
		return item;
	}

	useEffect(() => {
		const onLoad = loadFunction(setIsLoading, fetchData);
		onLoad();
	}, [clause, reload])

	return (
		<CustomTable
			options={{
				paged: true,
				pageSize: 10,
				...options
			}}
			title={title}
			columns={columns}
			isLoading={isLoading}
			toolbarAppend={toolbarAppend}
			onRowUpdate={hasPower && !hideEdit && loadFunction(setIsLoading, onRowUpdate)}
			onRowAdd={hasPower && loadFunction(setIsLoading, onRowAdd)}
			onAddClick={hasPower && onAddClick && loadFunction(setIsLoading, onAddClick)}
			onEditClick={hasPower && onEditClick && loadFunction(setIsLoading, onEditClick)}
			onRowDelete={hasPower && !hideDelete && loadFunction(setIsLoading, onRowDelete)}
			onDeleteClick={hasPower && onDeleteClick && loadFunction(setIsLoading, onDeleteClick)}
			data={data}
			canSelect={canSelect}
			parentChildData={parentChildData}
			treeList={treeList}
			onAddChildren={onAddChildren}
			openDetails={openDetails}
			detailsList={detailsList}
		/>
	)
}